var map = {
	"./africa/redpipe.vue": [
		"cuyM",
		14
	],
	"./black/redpipe.vue": [
		"0mWH",
		20
	],
	"./club-soft/redpipe.vue": [
		"Tfra",
		13
	],
	"./deep-blue/redpipe.vue": [
		"PT1S",
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "26hZ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/games/redpipe lazy ^\.\/.*\/redpipe\.vue$
// module id = 26hZ
// module chunks = 37